/**
 * Quiz editor empty-state — extracted verbatim from QuizEditorPage.jsx
 * during the Phase 3 refactor (no behaviour change).
 */
import { Plus, Sparkles, Wand2, Loader2 } from 'lucide-react';
import { Button } from '../../ui/button';

export function QuizEmptyState({ onAdd, onGen, generating }) {
  return (
    <div className="rounded-lg border border-dashed p-12 flex flex-col items-center text-center" data-testid="quiz-empty">
      <Wand2 className="w-10 h-10 text-muted-foreground/40 mb-3" />
      <h3 className="text-lg font-semibold">No questions yet</h3>
      <p className="text-sm text-muted-foreground max-w-md mt-1.5">
        Add questions manually, or have Lumyn draft a starting set from this section's content.
      </p>
      <div className="flex gap-2 mt-5">
        <Button onClick={onAdd} variant="outline" data-testid="empty-add-btn"><Plus className="w-4 h-4 mr-1" /> Add manually</Button>
        <Button onClick={onGen} disabled={generating} data-testid="empty-gen-btn">
          {generating ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Sparkles className="w-4 h-4 mr-1" />}
          Generate with AI
        </Button>
      </div>
    </div>
  );
}
